<p class="modal-title">Reedem Affiliatecode</p>
<div class="divider horizontal w-full"></div>
<form
  class="affiliate-code--form flex gap-8 items-center w-full"
  (submit)="$event.preventDefault(); redeemAffiliateCode()"
>
  <app-form-field
    label="Affiliate Code"
    [errorType]="'outline'"
    [id]="'code'"
    [placeholder]="'Enter Affiliate Code...'"
    [disabled]="isLoading()"
    [formControl]="$any(affiliateCode)"
    [error]="affiliateCode.getError('api')"
  />
  <button
    type="submit"
    class="affiliate-code--button"
    [disabled]="
      affiliateCode.getError('required') ||
      isLoading() ||
      affiliateCode.getError('api')
    "
  >
    <app-balance-icon icon="skins" color="var(--black)" />
    Reedem Affiliatecode
  </button>
</form>
